"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Lightbox } from "./Lightbox";
import type { ImageProps } from "@/components/ui/Image";
interface LightboxContextValue {
  openAt: (index: number) => void;
}
interface LightboxState {
  index: number;
  isOpen: boolean;
}
const LightboxContext = React.createContext<LightboxContextValue | null>(null);
export function useLightbox() {
  const context = React.useContext(LightboxContext);
  if (!context) {
    throw new Error("useLightbox must be used within a <LightboxProvider />");
  }
  return context;
}
export interface LightboxProviderProps {
  images: ImageProps[];
  children: React.ReactNode;
}
export const LightboxProvider: React.FC<LightboxProviderProps> = t0 => {
  const $ = _c(10);
  const {
    images,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      index: 0,
      isOpen: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [lightbox, setLightbox] = React.useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      openAt: index => setLightbox({
        index,
        isOpen: true
      })
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const value = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = open => {
      if (!open) {
        setLightbox(_temp);
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== images || $[4] !== lightbox.index || $[5] !== lightbox.isOpen) {
    t4 = <Lightbox images={images} startIndex={lightbox.index} open={lightbox.isOpen} onOpenChange={t3} />;
    $[3] = images;
    $[4] = lightbox.index;
    $[5] = lightbox.isOpen;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t4) {
    t5 = <LightboxContext.Provider value={value}>{children}{t4}</LightboxContext.Provider>;
    $[7] = children;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp(state) {
  return {
    ...state,
    isOpen: false
  };
}